

export const email_regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/

export const password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,24}$/

export const time_shift_regex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/